import * as React from 'react';
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import { Theme } from '@mui/styles';
import {Paper} from '@mui/material';
import * as keycode from "keycode";
import  {
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TablePagination,
  TableRow,
} from '@mui/material';
import {Checkbox} from '@mui/material';
import {Icon} from '@mui/material';
import {IconButton} from '@mui/material';
import SelectableTableToolbar from "./selectable-table-toolbar"
import SelectableTableHeader from "./selectable-table-header"
import * as request from "superagent"
import * as FileSaver from 'file-saver';
import ErrorView from '../error-view'
import PortalUserSubscription from '../../lib/models/portal-user-subscription'
import {isObject} from 'lodash'

const styles = (theme:Theme):StyleRules => ({
  container: {
    width: "100%",
  },
  // paper: {
  //   width: '100%',
  //   marginTop: theme.spacing.unit * 3,
  //   overflowX: 'auto',
  // },
  tableCell:{
    textOverflow: "ellipsis"
  },
  tableWrapper: {
    overflow: 'auto'
  }
  /*
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.A700,
          backgroundColor: theme.palette.secondary.A100,
        }
      : {
          color: theme.palette.secondary.A100,
          backgroundColor: theme.palette.secondary.A700,
        },
  */
})

export interface CellProps {
  column: Column
  data: any
  row: any

}

export interface HeaderProps {
  column: Column
}

export interface Column {
  id: string
  label: string
  disablePadding?: boolean
  numeric?: boolean
  cellRenderer?:  any
  headerRenderer?:  any
  omitExport?: boolean;
}

export interface Action {
  key: string
  icon: string
  label: string
  action: (selected: any) => void
}

interface Props extends React.HTMLProps<HTMLDivElement>{
  history?: any
  columns: Array<Column>
  tableData?: Array<any>
  title: string;
  rowActions?: Array<Action>
  summaryActions?: Array<Action>
  onRowClick?: Function
  onDoubleClick?: Function
  subscriptionUrl?: string
  allowExport?: boolean
  hideToolbar?: boolean
  rowsPerPage?: number
  headerStyle?: any
  rowsPerPageOptions?: Array<number>
  suppressNavigation?: boolean
  sortFunc?: (sortBy:string, sortOrder:string)=>(void)
  allowStickyFilter?: boolean
};

type State = {
  order: "desc" | "asc" | undefined 
  orderBy: string
  selectedItems: Array<any>
  data: Array<any>
  page: number
  rowsPerPage: number
  filterText:String
  error?: any
};


function getPropertyDescriptor(obj: any, prop: string) : PropertyDescriptor | undefined {
    let desc;
    // fix for IE11, getOwnPropertyDescriptor, and getPrototypeOf must have object is their first argument.
    if (isObject(obj)) {
      do {
        desc = Object.getOwnPropertyDescriptor(obj, prop);  
      } while (!desc && (obj = Object.getPrototypeOf(obj)));
    }
    return desc;
}

class SelectableTable extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
  constructor(props:Props & WithStyles<keyof typeof styles>) {
    super(props, {})
    this.state = {
      order: 'asc',
      orderBy: 'calories',
      selectedItems: [],
      data: props.tableData || new Array<any>(),
      page: 0,
      rowsPerPage: props.rowsPerPageOptions && props.rowsPerPageOptions.length > 0 ? props.rowsPerPageOptions[0] : 5,
      filterText: ""
    };
    if(props.subscriptionUrl && !props.history){
        console.error("When enabling subscription functionality by passing `subscriptionUrl`, you must also provide `history`.")
    } 
  }

  UNSAFE_componentWillReceiveProps(newProps:Props & WithStyles<keyof typeof styles>){
    this.setState({data: newProps.tableData || new Array<any>()})
  }


  handleRequestSort = (event:any, property:string) => {
    // console.log("handleRequestSort", property, event)
    const { data } = this.state
    const orderBy = property;
    let order: "desc" | "asc" | undefined  = 'desc';
    if(this.props.sortFunc){
      this.props.sortFunc(property, order)
    } else {
      if (this.state.orderBy === property && this.state.order === 'desc') {
        order = 'asc';
      }

      if(data && data.length > 0) {
          let sortedData:Array<any> = []
          sortedData = data.sort((a,b)=>{
			  			
            let c = a != null ? (a[orderBy].value || a[orderBy]) : null
			let d = b != null ? (b[orderBy].value || b[orderBy]) : null 
			
            if(c != null && typeof(c) == "string"){
              c = c.toLowerCase();
			}
			
            if(d != null && typeof(d) == "string"){
              d = d.toLowerCase();
			}
			
            const equality = c == d ? 0 : c < d ? -1 : 1
            
            return equality
          })

          // Reverse if Descending
          if(order === 'desc'){
            sortedData = sortedData.reverse()
          }

          this.setState({ data:sortedData, order:order, orderBy:orderBy }); 
      }
    }
  };

  handleSelectAllClick = (event:any, checked:boolean) => {
    if (checked) {
      this.setState({ selectedItems: this.state.data.map(n => n.id) });
      return;
    }
    this.setState({ selectedItems: [] });
  };

  handleKeyDown = (event:any, id:any) => {
    if (keycode(event) === 'space') {
      this.handleClick(event, id);
    }
  };

  handleRowClick = (row:any) => (evt:any) => {
      if(this.props.onRowClick) {
          this.props.onRowClick(row)
      }
  }

  handleDoubleClick = (row:any) => (evt:any) => {
    if(this.props.onDoubleClick) {
        this.props.onDoubleClick(row)
    }
  }

  handleFilterTextChange = (filterText:string) => {
    this.setState({filterText: filterText})
  }

  handleClick = (event:any, id:any) => {
    const { selectedItems } = this.state;

    const selectedIndex = selectedItems.indexOf(id);
    let newSelected = Array<any>();

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedItems, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedItems.slice(1));
    } else if (selectedIndex === selectedItems.length - 1) {
      newSelected = newSelected.concat(selectedItems.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedItems.slice(0, selectedIndex),
        selectedItems.slice(selectedIndex + 1),
      );
    }

    this.setState({ selectedItems: newSelected });
  };

  handleChangePage = (event:any, page:any) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = (event: any) => {
    this.setState({ rowsPerPage: event.target.value });
  };

  handleRowActionClick = (row: any, fn: (selected: any) => void) => (event:any) => {
    fn(row)
    event.preventDefault()
  }

  handleExportClick = () => {
      const excelColumns = new Array<any>() 
      for (const c of this.props.columns) {
          if (!c.omitExport) {
            excelColumns.push({
              headerText: c.label,
              attributeName: c.id
            })
          }
      }

      const convertedData = new Array<any>() 

      this.filterData(this.state.data, this.props.columns).forEach((r)=>{
          const row = {}
          excelColumns.forEach((col)=>{
              try{
                // If the r[field_name] is not an Object, take the default of the simple value
                row[col.attributeName] = r[col.attributeName].value || r[col.attributeName]
              } catch(e) {
                  console.error(e)
              }
          })
          convertedData.push(row)


      })

      request.post("/api/convert")
      .send({columns:excelColumns, data:convertedData})
      .responseType("blob")
      .set("Content-Type", "application/json").then((response)=>{
          if (response.ok) {
              FileSaver.saveAs(response.body, "export.xlsx")
          } else {
          // TODO: jdouglas - Figure out how to handle export errors 

          }

      }).catch((err)=>{
          // TODO: jdouglas - Figure out how to handle export errors 

      })

  }


  handleSubscribeClick = () => {
      const {subscriptionUrl, columns, history} = this.props
      
      if(!history){
        console.error("When enabling subscription functionality by passing `subscriptionUrl`, you must also provide `history`.")
        return
      }
      const excelColumns = new Array<any>() 
      for (const c of this.props.columns) {
          excelColumns.push({
              headerText: c.label,
              attributeName: c.id
            })
      }
      //create a Subscription token and then redirect to the subscription edit view in the root.
      const portalSub = new PortalUserSubscription({
          dataURL: subscriptionUrl,
          extendedAttributes: {
              columns: columns,
              excelColumns: excelColumns
          }
      })
      portalSub.save().then((sub:PortalUserSubscription)=>{
          // console.log(sub)
          //history.push("/subscriptions/" + sub.id.toString())
          window.location.href="/subscriptions/" + sub.id.toString() + "?return=" + encodeURI(window.location.href)
      }).catch((err)=>{
          this.setState({error:err})
      })


  }

  isSelected = (id:any) => this.state.selectedItems.indexOf(id) !== -1;

  filterData = (data:Array<any>, columns:any) => {
    var self = this;
    return data.filter((row)=>{
        for(let c of columns) {
          switch(typeof c) {
            case 'string':
              if(row[c] && row[c].indexOf(self.state.filterText) > -1){
                return true
              }
              break
            default:
              if(typeof row[c.id] == "object" && row[c.id] && row[c.id].value && row[c.id].value.toString().toLowerCase().indexOf && row[c.id].value.toString().toLowerCase().indexOf(self.state.filterText.toLowerCase()) > -1){
                return true
              }
              if(typeof row[c.id] == "string" && row[c.id] && row[c.id].toLowerCase().indexOf(self.state.filterText.toLowerCase()) > -1){
                return true
              }
          }
        }
        return false
      })
  }
  render () {
    const { classes }: { classes:ClassNameMap } = this.props
    const { columns, title, rowActions, summaryActions, onRowClick, onDoubleClick, subscriptionUrl, history, allowExport, hideToolbar, rowsPerPageOptions, suppressNavigation } = this.props
    const { data, order, orderBy, selectedItems, rowsPerPage, page, error } = this.state;

    let filteredData = data
    if(this.state.filterText) {
      filteredData = this.filterData(data, columns)
    }

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, filteredData.length - page * rowsPerPage);

    var sc, ec
    if (allowExport) {
        ec = this.handleExportClick
    }

    if (subscriptionUrl && history) {
        sc = this.handleSubscribeClick
    }
    return (
      <Paper className={classes.root}>
        <ErrorView classes={{}} error={error} />
    { !hideToolbar && <SelectableTableToolbar name={title} allowStickyFilter={this.props.allowStickyFilter} onSubscribeClick={sc} onExportClick={ec} title={title} selectedItems={selectedItems}  summaryActions={summaryActions} onFilterTextChange={this.handleFilterTextChange}/> }
        <div className={classes.tableWrapper}>
          <Table className={(classes.table || '')}>
            <SelectableTableHeader
              classes={{}}
              numSelected={selectedItems.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={this.handleSelectAllClick}
              onRequestSort={this.handleRequestSort}
              rowCount={data.length}
              columns={columns}
              includeActionColumn={ rowActions && rowActions.length > 0 }
              includeSelectionColumn={ summaryActions && summaryActions.length > 0}
            />
            <TableBody>
              {filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((n, idx1) => {
                
                // Commenting below out for now, the idx1 can be used for the rowKey since it should always be unique. 
                // var rowKey = idx1
                // if(rowKey && getPropertyDescriptor(rowKey, 'value')) {
                //   rowKey = rowKey.value
                // }

                const isSelected = this.isSelected(n.id);
                const dataColumns = columns.map((c:any, idx2:number)=>{
                  var val = n[c.id]
                  // jdouglas This block is present to accept both raw objects and objects whose properties are StringAttribute, DateAttribute, NumberAttribute, etc. Wed Dec 13 08:55:56 2017
                  if(val && getPropertyDescriptor(val, 'value')) {
                    val = val.value
                  }
                  const key = c.id + idx1.toString() + idx2.toString()
                  if(c.cellRenderer) {
                    const contents =  new c.cellRenderer({data: val, row: n, column: c})
                    return (
                      <TableCell key={key} style={c.colStyle || {}} align={ c.numeric ? 'right' : 'left'}  padding={ c.disablePadding ? "none" : "normal" } >{contents}</TableCell>
                    )

                  } else {
                    return (
                      <TableCell key={key} style={c.colStyle || {}} align={ c.numeric ? 'right' : 'left'} padding={ c.disablePadding ? "none" : "normal" }><span style={c.colStyle || {}}>{val}</span></TableCell>
                    )
                  }
                })

                var actionColumn 
                if(rowActions) {
                  const actionIcons = rowActions.map((a:Action)=>{
                    return (
                      <IconButton size="large" key={a.key} className={classes.actionButton} aria-label={a.label} onClick={this.handleRowActionClick(n, a.action)}>
                        <Icon>{a.icon}</Icon>
                      </IconButton>
                    )
                  }) 
                  actionColumn = <TableCell padding="none" style={{textAlign: 'right'}} key="rowActions">{actionIcons}</TableCell>
                }
                
                // console.log("filteredData.length", filteredData.length)

                return (
                  <TableRow
                    hover
                    onKeyDown={event => this.handleKeyDown(event, n.id)}
                    onClick={onRowClick ? this.handleRowClick(n) : undefined}
                    onDoubleClick={onDoubleClick ? this.handleDoubleClick(n) : undefined}
                    role="checkbox"
                    aria-checked={isSelected}
                    tabIndex={-1}
                    key={idx1}
                    selected={isSelected}
                  >
                    { summaryActions &&
                      <TableCell
                        onClick={event => this.handleClick(event, n.id)}
                        padding="checkbox">
                        <Checkbox checked={isSelected} />
                      </TableCell>
                    }
                    {dataColumns}
                    {actionColumn}
                  </TableRow>
                );
              })}
              {emptyRows > 0 && (
                <TableRow style={{ height: 49 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
            {!suppressNavigation && 
            <TableFooter >
              <TableRow style={{position: 'relative'}}>
                  <TablePagination
                    style={{position: 'absolute', right: 30}}
                    count={filteredData.length}
                    onPageChange={this.handleChangePage}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                    rowsPerPageOptions={rowsPerPageOptions}
                  />
              </TableRow>
            </TableFooter>}
          </Table>
        </div>
      </Paper>
    );


  }
}

export default withStyles(styles)(SelectableTable);

// {!suppressNavigation && <TableFooter>
//   <TableRow style={{position: 'relative'}}>
//     <div style={{position: 'absolute', right: 15}}>
//       <TablePagination
//         count={data.length}
//         rowsPerPage={rowsPerPage}
//         page={page}
//         onChangePage={this.handleChangePage}
//         onChangeRowsPerPage={this.handleChangeRowsPerPage}
//         rowsPerPageOptions={rowsPerPageOptions}
//       />
//     </div>
//   </TableRow>
// </TableFooter>}
